import { memo } from 'react';
import { handleDomBubbleEvent } from '@/utils/dom';
import {
  Modal,
  ModalHeader,
  ModalTitle,
  ModalContent,
  ModalFooter,
  ModalCloseButton,
  ModalConfirmButton,
} from '@/components/_ui/modal';
import { Spinner } from '@/components/_ui/spinner';
import { useRestoreTicketModal } from './use-restore-ticket-modal';

export type TRestoreTicketModalType = 'RestoreTicketModal';
export interface IRestoreTicketModalProps {
  spaceId: string;
  ticketId: string;
  onStart?: () => Promise<void> | void;

  onSuccess?: () => Promise<void> | void;
}

const RestoreTicketModal = memo(({ spaceId, ticketId, onStart, onSuccess }: IRestoreTicketModalProps) => {
  const {
    // FORM
    form,
    isOpen,
    isDisabledForm,
    isLoadingForm,

    // HANDLERS
    handleCancelModal,
    handleCloseModal,
    handleSubmitForm,
  } = useRestoreTicketModal({
    spaceId,
    ticketId,
    onSuccess,
    onStart,
  });

  // RENDER
  return (
    <Modal
      isOpen={isOpen}
      lockBodyScroll
      onClose={handleCloseModal}
      isCloseOutside={false}
      className="md:w-[500px] w-[345px] p-[24px]"
    >
      <ModalHeader>
        <ModalTitle>Are you sure you want to restore this ticket?</ModalTitle>
      </ModalHeader>
      <ModalContent>
        <form
          onSubmit={(e) => {
            handleDomBubbleEvent(e);
            form.handleSubmit(handleSubmitForm)(e);
          }}
          id="restore-ticketing-ticket-form"
          className="grid gap-[16px] mt-[16px]"
        >
          <span className="text-[14px] font-normal text-[#9D9D9C]">
            This ticket will be restored to your active list and can be updated again.
          </span>
        </form>
      </ModalContent>
      <ModalFooter>
        <ModalCloseButton
          onClick={(e) => {
            handleDomBubbleEvent(e);
            handleCancelModal();
          }}
        >
          Cancel
        </ModalCloseButton>
        <ModalConfirmButton form="restore-ticketing-ticket-form" type="submit" disabled={isDisabledForm}>
          {isLoadingForm ? <Spinner className="w-[18px] h-[18px]" /> : null} Restore
        </ModalConfirmButton>
      </ModalFooter>
    </Modal>
  );
});
RestoreTicketModal.displayName = 'RestoreTicketModal';
export default RestoreTicketModal;
